// eslint-disable-next-line import/prefer-default-export
import SliderHoc from './SliderHoc';

export default SliderHoc;
